module.exports = __webpack_public_path__ + "made-purchase-white.svg?458561726baaeb523b1e85505ec8a831";